module.exports = __webpack_public_path__ + "img/ca_success1.a002428f.png";